export default {
      id: "star-usage",
      viewBox: "0 0 426.667 426.667",
      url: __webpack_public_path__ + "app/svg/sprite.svg#star",
      toString: function () {
        return this.url;
      }
    }